import React from 'react';
import Card from '../layout/Card';
import { CircleX } from "lucide-react";

const ConversationsOnglets = ({ ongletConv,updateConvertionTalk,conversationTalk,closeConversation }) => {

    
    const isCurrent = (conv)=>{        
        if(!conversationTalk){
            return ""
        }
        return conversationTalk?.tokenuser == conv?.tokenuser ?"is-active" : ""
    }
    return (
        <div className='w100 oxs py1 df'>
            {ongletConv?.length > 0 && ongletConv.map((conv, conv_i) => (
                <div key={conv_i + "_onglet"} className='mr1'>
                    <div className='pr'>
                        <Card addClass={isCurrent(conv)}>
                            <button onClick={()=>updateConvertionTalk(conv)} className='cp'>
                                <p className='cw fr'>{conv.tokenuser}</p>
                            </button>
                            <button onClick={()=>closeConversation(conv.tokenuser)} className='btn-close-conv'><CircleX color='#f71717' size={18} /></button>
                        </Card>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ConversationsOnglets;